import React from "react";
import { ShieldAlert, Terminal } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function RequestClearance() {
  return <section data-section-id="238715" id="emergency-call-now" className="dark bg-background text-foreground relative flex flex-col items-center justify-center py-32 px-6 overflow-hidden border-y border-border">
      {}
      <div className="absolute inset-0 bg-background z-0" />

      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:32px_32px] z-0" />

      {}
      <div className="absolute top-0 left-0 w-full h-4 bg-[repeating-linear-gradient(-45deg,#000000,#000000_24px,#f97316_24px,#f97316_48px)] border-b border-primary/20 z-10 shadow-[0_4px_20px_rgba(0,0,0,0.5)]" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center">
        <div className="mb-8 p-5 border-2 border-primary/40 bg-primary/10 rounded-none inline-flex items-center justify-center shadow-[0_0_30px_rgba(249,115,22,0.2)]">
          <ShieldAlert className="w-14 h-14 text-primary" strokeWidth={2} />
        </div>

        <h2 className="font-default text-4xl md:text-5xl lg:text-7xl font-black tracking-tighter uppercase italic mb-8 text-foreground drop-shadow-[0_0_15px_rgba(249,115,22,0.3)]">
          Emergency Flat?
        </h2>

        <div className="w-full max-w-2xl border-l-4 border-primary pl-6 text-left mb-12">
          <p className="font-mono text-muted-foreground text-sm md:text-base leading-relaxed uppercase tracking-tight">
            Stranded in Los Angeles? Our rapid response tire team is on standby. 
            From Flat Tire Repair to urgent TPMS Sensor Service, we get you 
            back on the asphalt immediately. Do not wait—dispatch is active 
            24/7 for all emergency automotive tire failures.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 items-center justify-center w-full">
          <Link to="tel:+14243138474" className="w-full sm:w-auto group">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 rounded-sm font-default font-bold text-base uppercase tracking-widest border-2 border-primary bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 shadow-lg group-hover:shadow-primary/40 group-hover:-translate-y-1">
              <Terminal className="w-5 h-5 mr-3 opacity-80" />
              Call Now
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-4 bg-[repeating-linear-gradient(-45deg,#000000,#000000_24px,#f97316_24px,#f97316_48px)] border-t border-primary/20 z-10 shadow-[0_-4px_20px_rgba(0,0,0,0.5)]" />
    </section>;
}